const Blog = () => import('views/blog/Blog')
const ArticleIndex = () => import('views/blog/Article')
const ArticlePage = () => import('views/blog/ArticlePage')
const CategoryIndex = () => import('views/blog/CategoryIndex')
const CategoryPage = () => import('views/blog/CategoryPage')
const ArchivePage = () => import('views/blog/ArchivePage')
const AboutPage = () => import('views/blog/AboutPage')
const SearchPage = () => import('views/blog/SearchPage')

export default {
  path: '/blog',
  name: 'Blog',
  component: Blog,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'Blog',
      component: ArticleIndex,
      meta: { needAuth: false }
    },
    {
      path: '/blog',
      name: 'ArticleIndex',
      component: ArticleIndex,
      meta: { needAuth: false }
    },
    {
      path: '/blog/post/:articleId',
      name: 'ArticlePage',
      component: ArticlePage,
      meta: { needAuth: false }
    },
    {
      path: '/blog/category',
      name: 'CategoryIndex',
      component: CategoryIndex,
      meta: { needAuth: false }
    },
    {
      path: '/blog/category/post',
      name: 'CategoryPage',
      component: CategoryPage,
      meta: { needAuth: false }
    },
    {
      path: '/blog/tag',
      name: 'TagIndex',
      component: CategoryIndex,
      meta: { needAuth: false }
    },
    {
      path: '/blog/tag/post',
      name: 'TagPage',
      component: CategoryPage,
      meta: { needAuth: false }
    },
    {
      path: '/blog/archive',
      name: 'ArchivePage',
      component: ArchivePage,
      meta: { needAuth: false }
    },
    {
      path: '/blog/about',
      name: 'AboutPage',
      component: AboutPage,
      meta: { needAuth: false }
    },
    {
      path: '/blog/search',
      name: 'SearchPage',
      component: SearchPage,
      meta: { needAuth: false }
    }
  ]
}
